<script>
export default {
	props: {
		data: {
			type: Array,
			required: true
		},
		page: {
			type: Number,
			required: true
		}
	},
	methods: {
		changePage(page) {
			const total = this.data.length;
			if (page < 1) page = 1;
			if (page > total) page = total;
			this.$emit('updatePage', parseInt(page));
		},
	},
}
</script>
<template>
	<div class="row">
		<div class="col">
			<nav class="d-flex justify-content-center">
				<ul class="pagination pagination-custom mb-0">
					<li 
						v-show="data.length > 1"
						class="page-item"
						:class="page === 1 ? 'disabled' : '' "
					>
						<a 
						@click="changePage(page - 1)"
						href="javascript:"
						class="page-link border-0">
						<font-awesome-icon icon="fa-solid fa-angle-left"></font-awesome-icon>
						</a>
					</li>
					<li 
						v-for="item in data"
						:id="item.pagina"
						:key="item.pagina"
						class="page-item"
						:class="parseInt(page) === parseInt(item.pagina) ? 'active' : '' "
						>
						<a 
							@click="changePage(item.pagina)"
							class="page-link border-0" 
							href="javascript:"
							>
							{{ item.pagina }}
						</a>
					</li>
					<li 
						class="page-item"
						v-show="data.length > 1"
						:class="parseInt(page) === data.length ? 'disabled' : '' "
						>
						<a 
						@click="changePage(parseInt(page) + 1)"
						class="page-link border-0" 
						href="javascript:"
						>
						<font-awesome-icon icon="fa-solid fa-angle-right"></font-awesome-icon>						
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>
